'use strict';

var darkMobile375;
var hasRequiredDarkMobile375;

function requireDarkMobile375 () {
	if (hasRequiredDarkMobile375) return darkMobile375;
	hasRequiredDarkMobile375 = 1;

	/**
	 * Do not edit directly, this file was auto-generated.
	 */

	darkMobile375 = {
	  "theme": "dark-mobile375",
	  "type": {
	    "family": {
	      "base": "Mulish",
	      "decorative": "Besley"
	    }
	  },
	  "borderWeight": {
	    "medium": 2,
	    "small": 1,
	    "xsmall": 1
	  },
	  "column": {
	    "app": {
	      "container": 375,
	      "gutter": 20,
	      "margin": 20
	    },
	    "web": {
	      "container": 1440,
	      "gutter": 16,
	      "margin": 20
	    }
	  },
	  "gap": {
	    "0": 0,
	    "25": 1,
	    "50": 2,
	    "100": 4,
	    "200": 8,
	    "300": 12,
	    "400": 16,
	    "500": 20,
	    "600": 24,
	    "800": 32,
	    "1000": 40,
	    "1200": 48,
	    "1600": 64,
	    "3600": 144
	  },
	  "padding": {
	    "dynamic": {
	      "200": 4,
	      "400": 8,
	      "600": 16,
	      "800": 16,
	      "1000": 24,
	      "1200": 24
	    },
	    "static": {
	      "25": 1,
	      "50": 2,
	      "100": 4,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "400": 16,
	      "500": 20,
	      "600": 24,
	      "800": 32,
	      "1000": 40,
	      "1200": 48,
	      "1400": 56,
	      "1600": 64,
	      "4125": 165
	    }
	  },
	  "radius": {
	    "background": {
	      "large": 16,
	      "medium": 8,
	      "rounded": 300,
	      "small": 4,
	      "xlarge": 32,
	      "xsmall": 3
	    },
	    "surface": {
	      "large": 16,
	      "medium": 8,
	      "small": 4,
	      "xlarge": 32
	    }
	  },
	  "size": {
	    "height": {
	      "25": 1,
	      "75": 3,
	      "100": 4,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "350": 14,
	      "400": 16,
	      "450": 18,
	      "475": 19,
	      "500": 20,
	      "525": 21,
	      "600": 24,
	      "675": 27,
	      "700": 28,
	      "800": 32,
	      "850": 34,
	      "1000": 40,
	      "1050": 42,
	      "1100": 44,
	      "1300": 52,
	      "1400": 56,
	      "1550": 62,
	      "1600": 64,
	      "2000": 80,
	      "2200": 88,
	      "2750": 110,
	      "3000": 120,
	      "3650": 146,
	      "4000": 160,
	      "5000": 200,
	      "5600": 224,
	      "8375": 335,
	      "14600": 584,
	      "146003": 584
	    },
	    "width": {
	      "25": 1,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "350": 14,
	      "400": 16,
	      "450": 18,
	      "500": 20,
	      "600": 24,
	      "700": 28,
	      "800": 32,
	      "850": 34,
	      "950": 38,
	      "1000": 40,
	      "1050": 42,
	      "1100": 44,
	      "1300": 52,
	      "1400": 56,
	      "1550": 62,
	      "1600": 64,
	      "2000": 80,
	      "2200": 88,
	      "2350": 94,
	      "2750": 110,
	      "3000": 120,
	      "3650": 146,
	      "4000": 160,
	      "5000": 200,
	      "5250": 210,
	      "5600": 224,
	      "6500": 260,
	      "7500": 300,
	      "8375": 335,
	      "14600": 584
	    }
	  },
	  "asset": {
	    "blue": {
	      "100": "#0c1b29",
	      "200": "#102841",
	      "300": "#1a3c60",
	      "400": "#4577ad",
	      "500": "#6597ce",
	      "600": "#96bde7",
	      "700": "#d1e8ff",
	      "800": "#e6f1fc",
	      "900": "#ffffff",
	      "background": "#1a3c60",
	      "backItem": "#285685"
	    },
	    "green": {
	      "100": "#0c291e",
	      "200": "#124935",
	      "300": "#1f5b45",
	      "400": "#288563",
	      "500": "#42ad86",
	      "600": "#bfe8d9",
	      "700": "#f0fff9",
	      "800": "#fafffc",
	      "900": "#ffffff",
	      "background": "#1f5b45",
	      "backItem": "#206a4f"
	    },
	    "grey": {
	      "100": "#141719",
	      "200": "#1d2124",
	      "300": "#515357",
	      "400": "#2d3238",
	      "500": "#98999b",
	      "600": "#bcbdbf",
	      "700": "#e8e9ea",
	      "800": "#f7f7f7",
	      "900": "#ffffff",
	      "background": "#515357",
	      "backItem": "#22272b"
	    },
	    "orange": {
	      "100": "#29170c",
	      "200": "#4a2915",
	      "300": "#63371c",
	      "400": "#ad6234",
	      "500": "#cf7945",
	      "600": "#e7aa84",
	      "700": "#ffe3d1",
	      "800": "#fff3e8",
	      "900": "#ffffff",
	      "background": "#63371c",
	      "backItem": "#8a4e29"
	    },
	    "purple": {
	      "100": "#200f29",
	      "200": "#33193f",
	      "300": "#482359",
	      "400": "#865c99",
	      "500": "#b990cc",
	      "600": "#d8b1ec",
	      "700": "#f0d1ff",
	      "800": "#f2ecfe",
	      "900": "#ffffff",
	      "background": "#482359",
	      "backItem": "#693b80"
	    },
	    "red": {
	      "100": "#290f16",
	      "200": "#451522",
	      "300": "#5e1d2e",
	      "400": "#b23655",
	      "500": "#c74c6b",
	      "600": "#ea8aa3",
	      "700": "#ffd1dd",
	      "800": "#feeef2",
	      "900": "#ffffff",
	      "background": "#5e1d2e",
	      "backItem": "#8f2843"
	    },
	    "sand": {
	      "100": "#000000",
	      "200": "#493612",
	      "300": "#5e4317",
	      "400": "#8e703e",
	      "500": "#bba37c",
	      "600": "#e2d0ac",
	      "700": "#efe5d1",
	      "800": "#f6f1e5",
	      "900": "#ffffff",
	      "background": "#5e4317",
	      "backItem": "#6b5024"
	    },
	    "shade": {
	      "white": "#ffffff"
	    }
	  },
	  "accent": {
	    "blue": {
	      "backgroundBold": "#6597ce",
	      "backgroundLevel1": "#102841",
	      "backgroundLevel2": "#1a3c60",
	      "border": "#4577ad",
	      "icon": "#d1e8ff",
	      "text": "#d1e8ff",
	      "textBold": "#e6f1fc"
	    },
	    "green": {
	      "backgroundBold": "#42ad86",
	      "backgroundLevel1": "#124935",
	      "backgroundLevel2": "#1f5b45",
	      "border": "#f0fff9",
	      "borderBold": "#fafffc",
	      "icon": "#f0fff9",
	      "iconBold": "#fafffc",
	      "text": "#f0fff9",
	      "textBold": "#fafffc"
	    },
	    "orange": {
	      "backgroundBold": "#cf7945",
	      "backgroundLevel1": "#4a2915",
	      "backgroundLevel2": "#63371c",
	      "border": "#ad6234",
	      "icon": "#ffe3d1",
	      "text": "#ffe3d1",
	      "textBold": "#fff3e8"
	    },
	    "purple": {
	      "backgroundBold": "#b990cc",
	      "backgroundLevel1": "#33193f",
	      "backgroundLevel2": "#482359",
	      "border": "#865c99",
	      "icon": "#f0d1ff",
	      "text": "#f0d1ff",
	      "textBold": "#f2ecfe"
	    },
	    "red": {
	      "backgroundBold": "#ea8aa3",
	      "backgroundLevel1": "#451522",
	      "backgroundLevel2": "#5e1d2e",
	      "border": "#b23655",
	      "icon": "#ffd1dd",
	      "text": "#ffd1dd",
	      "textBold": "#feeef2"
	    }
	  },
	  "brand": {
	    "apple": {
	      "button": {
	        "border": "#ffffff",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": "#000000"
	    },
	    "emerson": {
	      "gold": "#dca270",
	      "silver": "#949494"
	    },
	    "facebook": {
	      "logo": "#3c5a99"
	    },
	    "fullscript": {
	      "logo": {
	        "leaf": "#88b04b",
	        "wordmark": "#ffffff"
	      }
	    },
	    "google": {
	      "button": {
	        "border": "#f2f2f2",
	        "fill": "#f2f2f2",
	        "text": "#1f1f1f"
	      },
	      "icon": {
	        "blue": "#4285f4",
	        "green": "#34a853",
	        "red": "#ea4335",
	        "yellow": "#fbbc05"
	      }
	    },
	    "linkedin": {
	      "logo": "#2867b2"
	    },
	    "twitterX": {
	      "logo": "#ffffff"
	    }
	  },
	  "critical": {
	    "backgroundBold": "#ea8aa3",
	    "backgroundLevel1": "#451522",
	    "backgroundLevel2": "#5e1d2e",
	    "border": "#b23655",
	    "icon": "#ffd1dd",
	    "text": "#ffd1dd",
	    "textBold": "#feeef2"
	  },
	  "discovery": {
	    "backgroundBold": "#bba37c",
	    "backgroundLevel1": "#493612",
	    "backgroundLevel2": "#5e4317",
	    "border": "#6b5024",
	    "icon": "#efe5d1",
	    "text": "#efe5d1",
	    "textBold": "#f6f1e5"
	  },
	  "info": {
	    "backgroundBold": "#6597ce",
	    "backgroundLevel1": "#102841",
	    "backgroundLevel2": "#1a3c60",
	    "border": "#4577ad",
	    "icon": "#d1e8ff",
	    "text": "#d1e8ff",
	    "textBold": "#e6f1fc"
	  },
	  "inverse": {
	    "backgroundBold": "#f7f7f7",
	    "backgroundMuted": "#e8e9ea",
	    "border": "#f7f7f7",
	    "borderBold": "#141719",
	    "icon": "#1d2124",
	    "iconBold": "#141719",
	    "text": "#1d2124",
	    "textBold": "#141719"
	  },
	  "neutral": {
	    "backgroundLevel0": "#141719",
	    "backgroundLevel1": "#1d2124",
	    "backgroundLevel2": "#2d3238",
	    "backgroundLevel3": "#515357",
	    "border": "#686b70",
	    "borderBold": "#98999b",
	    "borderMuted": "#1d2124",
	    "divider": "#515357",
	    "icon": "#e8e9ea",
	    "iconBold": "#e8e9ea",
	    "text": "#e8e9ea",
	    "textBold": "#ffffff",
	    "textSubtle": "#bcbdbf"
	  },
	  "recur": {
	    "backgroundBold": "#b990cc",
	    "backgroundLevel1": "#33193f",
	    "backgroundLevel2": "#482359",
	    "border": "#865c99",
	    "icon": "#f0d1ff",
	    "text": "#f0d1ff",
	    "textBold": "#f2ecfe"
	  },
	  "smart": {
	    "backgroundBold1": "#8fa7c1",
	    "backgroundBold2": "#b0c1d4",
	    "backgroundBold3": "#c8d6e4"
	  },
	  "success": {
	    "backgroundBold": "#42ad86",
	    "backgroundLevel1": "#124935",
	    "backgroundLevel2": "#1f5b45",
	    "border": "#288563",
	    "icon": "#f0fff9",
	    "text": "#f0fff9",
	    "textBold": "#fafffc"
	  },
	  "surface": {
	    "inverse": "#e8e9ea",
	    "level0": "#141719",
	    "level1": "#1d2124",
	    "overflow": "#2d3238",
	    "overlay": "#2d3238",
	    "overlayBackdrop": "#00000066",
	    "overlayInverted": "#e8e9ea",
	    "raised": "#2d3238"
	  },
	  "warning": {
	    "backgroundBold": "#cf7945",
	    "backgroundLevel1": "#4a2915",
	    "backgroundLevel2": "#63371c",
	    "border": "#ad6234",
	    "icon": "#ffe3d1",
	    "text": "#ffe3d1",
	    "textBold": "#fff3e8"
	  },
	  "effect": {
	    "blur": {
	      "price": 6
	    },
	    "elevation": {
	      "overflow": {
	        "blur": 4,
	        "colour": "#14171999",
	        "opacity": 60,
	        "spread": 0,
	        "x": 0,
	        "y": -2
	      },
	      "overflowFade": "#141719",
	      "overlay": {
	        "blur": 16,
	        "colour": "#14171999",
	        "opacity": 60,
	        "spread": 0,
	        "x": 0,
	        "y": 8
	      },
	      "raised": {
	        "blur": 4,
	        "colour": "#14171999",
	        "opacity": 60,
	        "spread": 0,
	        "x": 0,
	        "y": 2
	      }
	    },
	    "focused": {
	      "border": "#015fcc",
	      "stroke": 2
	    },
	    "overlay": "#ffffff33",
	    "skeleton": {
	      "backgroundLevel0": "#1d212400",
	      "backgroundLevel1": "#22272b80",
	      "backgroundLevel2": "#2d3238",
	      "radius": 4
	    },
	    "state": {
	      "disabled": {
	        "opacity": "0.6"
	      },
	      "hovered": {
	        "background": "#ffffff14",
	        "backgroundBold": "#00000029",
	        "border": "#ffffff14",
	        "borderBold": "#ffffff47",
	        "icon": "#ffffff14",
	        "iconBold": "#00000029",
	        "inverse": {
	          "background": "#00000014",
	          "backgroundBold": "#00000029",
	          "border": "#00000014",
	          "borderBold": "#00000014",
	          "icon": "#00000014",
	          "text": "#00000014"
	        },
	        "text": "#ffffff14",
	        "textBold": "#00000029"
	      },
	      "pressed": {
	        "background": "#ffffff29",
	        "backgroundBold": "#00000047",
	        "border": "#ffffff29",
	        "borderBold": "#ffffffcc",
	        "icon": "#ffffff29",
	        "iconBold": "#00000047",
	        "inverse": {
	          "background": "#00000029",
	          "backgroundBold": "#00000047",
	          "border": "#00000029",
	          "borderBold": "#000000cc",
	          "icon": "#00000029",
	          "text": "#00000029"
	        },
	        "text": "#ffffff29",
	        "textBold": "#00000047"
	      },
	      "readOnly": {
	        "opacity": "0.8"
	      },
	      "shortPressed": {
	        "opacity": "0.6"
	      }
	    }
	  },
	  "typography": {
	    "letterSpacing": {
	      "body": 0,
	      "heading": 0,
	      "label": 0,
	      "title": 0
	    },
	    "lineHeight": {
	      "bodyLg": 26,
	      "bodyMd": 23,
	      "bodySm": 20,
	      "bodyXs": 17,
	      "headingLg": 55,
	      "headingMd": 50,
	      "headingSm": 43,
	      "labelLg": 26,
	      "labelMd": 23,
	      "labelSm": 20,
	      "labelXs": 17,
	      "titleLg": 38,
	      "titleMd": 28,
	      "titleSm": 24
	    },
	    "textSize": {
	      "bodyLg": 17,
	      "bodyMd": 15,
	      "bodySm": 13,
	      "bodyXs": 11,
	      "headingLg": 34,
	      "headingMd": 31,
	      "headingSm": 27,
	      "labelLg": 17,
	      "labelMd": 15,
	      "labelSm": 13,
	      "labelXs": 11,
	      "titleLg": 24,
	      "titleMd": 22,
	      "titleSm": 19
	    }
	  },
	  "weight": {
	    "bold": "700",
	    "medium": "500",
	    "regular": "400",
	    "semibold": "600"
	  },
	  "accordionN": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderWeight": 1,
	    "gap": 16,
	    "paddingY": 20,
	    "radius": 8,
	    "text": "#e8e9ea"
	  },
	  "avatarN": {
	    "backgroundAvatar": "#2d3238",
	    "height": {
	      "large": 120,
	      "medium": 80,
	      "small": 56,
	      "xsmall": 40
	    },
	    "lineHeight": 41,
	    "radius": 300,
	    "text": "#ffffff",
	    "textSize": 32,
	    "width": {
	      "large": 120,
	      "medium": 80,
	      "small": 56,
	      "xsmall": 40
	    }
	  },
	  "badgeN": {
	    "critical": {
	      "background": "#ea8aa3",
	      "text": "#1d2124"
	    },
	    "height": {
	      "medium": 20,
	      "small": 12,
	      "xsmall": 8
	    },
	    "inverse": {
	      "background": "#2d3238",
	      "text": "#e8e9ea"
	    },
	    "neutral": {
	      "background": "#f7f7f7",
	      "text": "#1d2124"
	    },
	    "paddingX": 4,
	    "paddingY": 4,
	    "radius": 300,
	    "recur": {
	      "background": "#b990cc",
	      "text": "#1d2124"
	    },
	    "success": {
	      "background": "#42ad86",
	      "text": "#1d2124"
	    },
	    "width": {
	      "medium": 20,
	      "small": 12,
	      "xsmall": 8
	    }
	  },
	  "boxN": {
	    "alternate": {
	      "background": "#141719",
	      "border": "#686b70"
	    },
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "discovery": {
	      "background": "#493612",
	      "border": "#6b5024"
	    },
	    "info": {
	      "background": "#102841",
	      "border": "#4577ad"
	    },
	    "neutral": {
	      "background": "#1d2124",
	      "border": "#686b70"
	    },
	    "paddingX": {
	      "large": 16,
	      "small": 8,
	      "xsmall": 4
	    },
	    "paddingY": {
	      "large": 16,
	      "small": 8,
	      "xsmall": 4
	    },
	    "recur": {
	      "background": "#33193f",
	      "border": "#865c99"
	    },
	    "slot": {
	      "border": "#686b70",
	      "icon": "#e8e9ea",
	      "text": "#ffffff"
	    },
	    "success": {
	      "background": "#124935",
	      "border": "#288563"
	    },
	    "warning": {
	      "background": "#4a2915",
	      "border": "#ad6234"
	    }
	  },
	  "buttonN": {
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "buttonBase": {
	      "icon": {
	        "critical": "#ffd1dd",
	        "discovery": "#efe5d1",
	        "info": "#d1e8ff",
	        "neutral": "#e8e9ea",
	        "recur": "#f0d1ff",
	        "success": "#f0fff9",
	        "warning": "#ffe3d1"
	      },
	      "text": {
	        "critical": "#feeef2",
	        "discovery": "#f6f1e5",
	        "info": "#e6f1fc",
	        "neutral": "#ffffff",
	        "recur": "#f2ecfe",
	        "success": "#fafffc",
	        "warning": "#fff3e8"
	      }
	    },
	    "gap": 8,
	    "height": {
	      "medium": 44,
	      "small": 34
	    },
	    "paddingX": 16,
	    "primary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "inverse": {
	        "background": "#1d2124",
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "background": "#e8e9ea",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "smart": {
	        "icon": "#1d2124",
	        "text": "#141719"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "border": "#b23655",
	        "icon": "#ffd1dd",
	        "iconAlt": "#1d2124",
	        "text": "#ffd1dd",
	        "textAlt": "#141719"
	      },
	      "inverse": {
	        "border": "#1d2124",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "neutral": {
	        "border": "#f7f7f7",
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      },
	      "smart": {
	        "icon": "#e8e9ea",
	        "iconAlt": "#141719",
	        "text": "#ffffff",
	        "textAlt": "#141719"
	      }
	    },
	    "ssoButtonN": {
	      "apple": {
	        "background": "#ffffff",
	        "border": "#ffffff",
	        "icon": "#000000",
	        "text": "#000000"
	      },
	      "borderWeight": 1,
	      "gap": 12,
	      "google": {
	        "background": "#f2f2f2",
	        "border": "#f2f2f2",
	        "icon": {
	          "blue": "#4285f4",
	          "green": "#34a853",
	          "red": "#ea4335",
	          "yellow": "#fbbc05"
	        },
	        "text": "#1f1f1f"
	      },
	      "height": 44,
	      "padding": 16,
	      "radius": 8
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "neutral": {
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      }
	    },
	    "width": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    }
	  },
	  "carouselN": {
	    "borderRadius": 8,
	    "gap": {
	      "large": 16,
	      "medium": 12,
	      "small": 8
	    }
	  },
	  "checkboxN": {
	    "background": {
	      "default": "#141719",
	      "selected": "#f7f7f7"
	    },
	    "border": "#98999b",
	    "borderRadius": 3,
	    "borderWeight": 1,
	    "gap": 16,
	    "height": {
	      "large": 34,
	      "small": 18
	    },
	    "icon": "#1d2124",
	    "text": "#e8e9ea",
	    "width": {
	      "large": 34,
	      "small": 18
	    }
	  },
	  "chipN": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "gap": {
	      "small": 8,
	      "xsmall": 4
	    },
	    "icon": "#e8e9ea",
	    "minheight": 34,
	    "multi": {
	      "background": {
	        "selected": "#515357"
	      }
	    },
	    "paddingL": {
	      "medium": 12,
	      "small": 8
	    },
	    "paddingR": {
	      "medium": 12,
	      "small": 8
	    },
	    "paddingX": 12,
	    "paddingY": 4,
	    "single": {
	      "background": {
	        "selected": "#e8e9ea"
	      },
	      "text": {
	        "selected": "#1d2124"
	      }
	    },
	    "text": "#ffffff"
	  },
	  "dividerN": {
	    "border": "#515357",
	    "borderWeight": 1,
	    "gap": 16,
	    "height": 20,
	    "text": "#bcbdbf"
	  },
	  "emptyStateN": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "gap": {
	      "medium": 16,
	      "small": 8
	    },
	    "paddingX": 24,
	    "paddingY": 24,
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff"
	  },
	  "headingN": {
	    "background": "#141719",
	    "paddingB": {
	      "large": 20,
	      "medium": 12,
	      "small": 8,
	      "xsmall": 4
	    },
	    "paddingY": 20,
	    "text": "#e8e9ea"
	  },
	  "iconButtonN": {
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "height": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    },
	    "primary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "icon": "#1d2124"
	      },
	      "inverse": {
	        "background": "#1d2124",
	        "icon": "#e8e9ea"
	      },
	      "neutral": {
	        "background": "#e8e9ea",
	        "icon": "#1d2124"
	      },
	      "smart": {
	        "icon": "#1d2124"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "border": "#b23655",
	        "icon": "#ffd1dd",
	        "iconAlt": "#1d2124"
	      },
	      "inverse": {
	        "border": "#1d2124",
	        "icon": "#1d2124"
	      },
	      "neutral": {
	        "border": "#f7f7f7",
	        "icon": "#e8e9ea"
	      },
	      "smart": {
	        "icon": "#e8e9ea",
	        "iconAlt": "#141719"
	      }
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#1d2124"
	      },
	      "neutral": {
	        "icon": "#e8e9ea"
	      }
	    },
	    "width": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    }
	  },
	  "iconN": {
	    "alternate": {
	      "background": "#141719",
	      "icon": "#e8e9ea"
	    },
	    "background": "#2d3238",
	    "backgroundHeight": {
	      "large": 52,
	      "medium": 44,
	      "small": 34,
	      "xlarge": 64,
	      "xsmall": 24
	    },
	    "backgroundWidth": {
	      "large": 52,
	      "medium": 44,
	      "small": 34,
	      "xlarge": 64,
	      "xsmall": 24
	    },
	    "borderRadius": {
	      "circular": 300,
	      "rectangular": 8
	    },
	    "critical": {
	      "background": "#5e1d2e",
	      "icon": "#ffd1dd"
	    },
	    "discovery": {
	      "background": "#5e4317",
	      "icon": "#efe5d1"
	    },
	    "iconHeight": {
	      "large": 24,
	      "medium": 20,
	      "small": 16,
	      "xsmall": 14
	    },
	    "iconWidth": {
	      "large": 24,
	      "medium": 20,
	      "small": 16,
	      "xsmall": 14
	    },
	    "info": {
	      "background": "#1a3c60",
	      "icon": "#d1e8ff"
	    },
	    "inverse": {
	      "background": "#e8e9ea",
	      "icon": "#1d2124"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "icon": "#e8e9ea"
	    },
	    "recur": {
	      "background": "#482359",
	      "icon": "#f0d1ff"
	    },
	    "success": {
	      "background": "#1f5b45",
	      "icon": "#f0fff9"
	    },
	    "warning": {
	      "background": "#63371c",
	      "icon": "#ffe3d1"
	    }
	  },
	  "inputN": {
	    "background": "#141719",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "critical": {
	      "border": "#b23655",
	      "icon": "#ffd1dd",
	      "text": "#ffd1dd"
	    },
	    "gap": 16,
	    "height": {
	      "large": 52,
	      "small": 28
	    },
	    "iconHeight": 24,
	    "iconWidth": 24,
	    "neutral": {
	      "border": "#686b70",
	      "icon": "#e8e9ea",
	      "text": "#e8e9ea"
	    },
	    "paddingX": 16,
	    "paddingY": 16
	  },
	  "string": {
	    "label": "Label"
	  },
	  "linkN": {
	    "borderWeight": 1,
	    "gap": 4,
	    "height": 1,
	    "inverse": {
	      "border": "#141719",
	      "text": "#1d2124"
	    },
	    "neutral": {
	      "border": "#98999b",
	      "text": "#e8e9ea"
	    },
	    "padding": 2,
	    "success": {
	      "border": "#f0fff9",
	      "text": "#f0fff9"
	    }
	  },
	  "listN": {
	    "background": {
	      "accentBlue": "#102841",
	      "accentGreen": "#124935",
	      "neutral": "#141719",
	      "selected": "#2d3238"
	    },
	    "border": "#515357",
	    "borderWeight": {
	      "medium": 2,
	      "small": 1
	    },
	    "gap": {
	      "large": 12,
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "paddingR": 8,
	    "paddingX": {
	      "medium": 12,
	      "small": 4
	    },
	    "paddingY": 12,
	    "radius": 8,
	    "textContent": "#bcbdbf",
	    "textLabel": "#e8e9ea"
	  },
	  "messageN": {
	    "borderRadius": 8,
	    "critical": {
	      "background": "#5e1d2e"
	    },
	    "gap": {
	      "large": 16,
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "info": {
	      "background": "#1a3c60"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "textBody": "#bcbdbf",
	      "textHeading": "#ffffff"
	    },
	    "paddingX": 8,
	    "paddingY": 12,
	    "success": {
	      "background": "#1f5b45"
	    },
	    "warning": {
	      "background": "#63371c"
	    }
	  },
	  "navigationBarN": {
	    "background": "#141719",
	    "border": "#515357",
	    "borderWeight": 1,
	    "gap": 8,
	    "paddingY": 20,
	    "text": "#e8e9ea"
	  },
	  "pillN": {
	    "critical": {
	      "background": "#5e1d2e",
	      "text": "#ffd1dd"
	    },
	    "discovery": {
	      "background": "#5e4317",
	      "text": "#efe5d1"
	    },
	    "gap": 4,
	    "height": {
	      "large": 27,
	      "medium": 21,
	      "small": 19
	    },
	    "info": {
	      "background": "#1a3c60",
	      "text": "#d1e8ff"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "text": "#e8e9ea"
	    },
	    "paddingX": {
	      "large": 2,
	      "medium": 2,
	      "small": 1
	    },
	    "paddingY": 8,
	    "radius": 300,
	    "recur": {
	      "background": "#482359",
	      "text": "#f0d1ff"
	    },
	    "success": {
	      "background": "#1f5b45",
	      "text": "#f0fff9"
	    },
	    "warning": {
	      "background": "#63371c",
	      "text": "#ffe3d1"
	    }
	  },
	  "priceN": {
	    "gap": 4,
	    "textDiscount": "#f0fff9",
	    "textRegular": "#ffffff",
	    "textSubtle": "#bcbdbf"
	  },
	  "productCardN": {
	    "background": "#2d3238",
	    "gap": {
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "paddingX": 12,
	    "paddingY": {
	      "medium": 12,
	      "small": 4
	    },
	    "radius": 8,
	    "text": "#bcbdbf",
	    "title": "#ffffff"
	  },
	  "productImageN": {
	    "_11": {
	      "large": {
	        "borderRadius": 8,
	        "height": 110,
	        "width": 110
	      },
	      "medium": {
	        "borderRadius": 4,
	        "height": 88,
	        "width": 88
	      },
	      "small": {
	        "borderRadius": 4,
	        "height": 64,
	        "width": 64
	      },
	      "xlarge": {
	        "borderRadius": 16,
	        "height": 200,
	        "width": 200
	      },
	      "xsmall": {
	        "borderRadius": 4,
	        "height": 42,
	        "width": 42
	      },
	      "xxlarge": {
	        "borderRadius": 16,
	        "height": 335,
	        "width": 335
	      },
	      "xxsmall": {
	        "borderRadius": 4,
	        "height": 32,
	        "width": 32
	      }
	    },
	    "_12": {
	      "xxsmall": {
	        "borderRadius": 4,
	        "height": 64,
	        "width": 32
	      }
	    },
	    "background": "#ffffff",
	    "fSbadge": {
	      "background": "#124935",
	      "icon": "#f0fff9",
	      "medium": {
	        "height": 24,
	        "icon": {
	          "height": 16,
	          "width": 16
	        },
	        "padding": 4,
	        "width": 24
	      },
	      "small": {
	        "height": 12,
	        "icon": {
	          "height": 8,
	          "width": 8
	        },
	        "padding": 2,
	        "width": 12
	      }
	    },
	    "padding": 4,
	    "status": {
	      "critical": "#451522",
	      "height": 20,
	      "neutral": "#1d2124",
	      "warning": "#4a2915",
	      "width": 20
	    }
	  },
	  "radioN": {
	    "background": {
	      "default": "#141719",
	      "selected": "#f7f7f7"
	    },
	    "border": "#98999b",
	    "borderRadius": 300,
	    "borderWeight": 1,
	    "gap": 16,
	    "height": {
	      "large": 34,
	      "small": 20
	    },
	    "text": "#e8e9ea",
	    "width": {
	      "large": 34,
	      "small": 20
	    }
	  },
	  "searchN": {
	    "background": "#1d2124",
	    "borderRadius": 8,
	    "gap": 8,
	    "height": {
	      "large": 44,
	      "small": 24
	    },
	    "icon": "#e8e9ea",
	    "paddingX": 16,
	    "text": "#e8e9ea",
	    "width": {
	      "small": 24
	    }
	  },
	  "segmentedControlN": {
	    "background": "#2d3238",
	    "backgroundSegment": "#141719",
	    "gap": 4,
	    "padding": 4,
	    "paddingX": 4,
	    "paddingY": 16,
	    "radius": 32,
	    "radiusSegement": 16,
	    "text": "#e8e9ea"
	  },
	  "sheetN": {
	    "backgroundScrim": "#ffffff33",
	    "backgroundSheet": "#141719",
	    "gap": {
	      "large": 20,
	      "medium": 12,
	      "small": 4
	    },
	    "grabber": {
	      "background": "#515357",
	      "borderRadius": 4,
	      "height": 4,
	      "width": 44
	    },
	    "paddingX": {
	      "large": 20,
	      "medium": 16,
	      "small": 8
	    },
	    "paddingY": {
	      "medium": 20,
	      "small": 8
	    },
	    "radius": 32,
	    "textSubtitle": "#bcbdbf",
	    "textTitle": "#e8e9ea"
	  },
	  "snackbarN": {
	    "background": "#f7f7f7",
	    "gap": 16,
	    "paddingBottom": 16,
	    "paddingLeft": 12,
	    "paddingRight": 8,
	    "paddingY": 8,
	    "radius": 8,
	    "textLabel": "#141719"
	  },
	  "space": {
	    "gap": {
	      "large": 20,
	      "medium": 16,
	      "small": 12,
	      "xlarge": 24,
	      "xsmall": 8,
	      "xxlarge": 32,
	      "xxsmall": 4,
	      "xxxlarge": 40
	    },
	    "padding": {
	      "large": 16,
	      "medium": 12,
	      "small": 8,
	      "xlarge": 20,
	      "xsmall": 4
	    }
	  },
	  "statusN": {
	    "borderRadius": 4,
	    "critical": {
	      "background": "#5e1d2e",
	      "icon": "#ffd1dd",
	      "text": "#feeef2"
	    },
	    "gap": {
	      "medium": 8,
	      "small": 4
	    },
	    "height": {
	      "medium": 34,
	      "small": 24
	    },
	    "icon": {
	      "height": 8,
	      "radius": 300,
	      "width": 8
	    },
	    "info": {
	      "background": "#1a3c60",
	      "icon": "#d1e8ff",
	      "text": "#e6f1fc"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "icon": "#e8e9ea",
	      "text": "#ffffff"
	    },
	    "paddingX": 8,
	    "success": {
	      "background": "#1f5b45",
	      "icon": "#f0fff9",
	      "text": "#fafffc"
	    },
	    "warning": {
	      "background": "#63371c",
	      "icon": "#ffe3d1",
	      "text": "#fff3e8"
	    }
	  },
	  "tabNavN": {
	    "active": "#124935",
	    "background": "#141719",
	    "border": "#515357",
	    "borderWeight": 1,
	    "gap": 4,
	    "paddingB": 16,
	    "paddingT": 12,
	    "paddingY": 20,
	    "radius": 16,
	    "text": "#e8e9ea"
	  },
	  "tabN": {
	    "border": "#686b70",
	    "borderActive": "#42ad86",
	    "borderWeight": 1,
	    "borderWeightActive": 2,
	    "gap": 32,
	    "paddingX": 16,
	    "paddingY": 20,
	    "text": "#e8e9ea"
	  },
	  "toggleN": {
	    "button": {
	      "background": "#141719",
	      "height": 24,
	      "paddingX": 2,
	      "paddingY": 2,
	      "width": 24
	    },
	    "gap": 12,
	    "icon": {
	      "height": 16,
	      "width": 16
	    },
	    "radius": 300,
	    "text": "#e8e9ea",
	    "track": {
	      "backgroundDefault": "#42ad86",
	      "backgroundDisabled": "#515357",
	      "height": 28,
	      "width": 52
	    }
	  },
	  "tooltipN": {
	    "surface": "#e8e9ea",
	    "textBody": "#1d2124",
	    "textHeading": "#141719"
	  }
	};
	
	return darkMobile375;
}

exports.__require = requireDarkMobile375;
//# sourceMappingURL=dark-mobile375.cjs.map
